import axios from 'axios';

export const getEntityDetail = async (entityId) => axios.get(`/api/farm/entity/${entityId}/`);
export const getRanchDetail = async (ranchId) => axios.get(`/api/farm/ranch/${ranchId}/`);
export const getBlockDetail = async (blockId) => axios.get(`/api/farm/block/${blockId}/`);

export const getEntityList = async () => axios.get('/api/farm/entity/');
export const getRanchList = async () => axios.get('/api/farm/ranch/');
export const getBlockList = async () => axios.get('/api/farm/block/');

export const getAvailableRanchList = async () => axios.get('/api/farm/ranch/available/');
